var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGear = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  className: "_dm-svg",
  focusable: "false",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16 8.985v-2l-2.39-.996a5.013 5.013 0 00-.223-.547l.965-2.402-1.415-1.414-2.381.98a5.608 5.608 0 00-.559-.231L8.983 0h-2l-.989 2.367a5.86 5.86 0 00-.58.235l-2.377-.955-1.414 1.414.969 2.356c-.094.194-.17.391-.243.594L-.003 7.017v2l2.353.98c.072.203.151.4.244.594l-.951 2.371 1.414 1.414 2.362-.973c.189.09.383.162.582.23L7.012 16h2l.99-2.379c.19-.07.377-.145.556-.23l2.399.961 1.414-1.414-.985-2.386c.084-.18.152-.361.219-.547l2.391-1.02zM7.984 11a3.001 3.001 0 010-6 3.001 3.001 0 010 6z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGear);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Gear.6acc47fa009a3af312982be3860b8d66.svg";